<td class="pia-listsBlock-item">
  <div class="pia-listsBlock-item-actions">
    @if (!base.is_example) {
    <a [routerLink]="['/knowledge_bases', base.id]" class="btn pia-tooltip">
      <fa-icon [icon]="faPencil"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.edit' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.edit" | translate }}</span
      >
    </a>
    } @else {
    <a [routerLink]="['/knowledge_bases', base.id]" class="btn pia-tooltip">
      <fa-icon [icon]="faEye"></fa-icon>
      <span
        title="{{ 'homepage.cards.item.consult_pia' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.consult" | translate }}</span
      >
    </a>
    } @if (!base.is_example) {
    <a href="javascript:;" (click)="export(base.id)" class="btn pia-tooltip">
      <fa-icon [icon]="faDownload"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.export' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.export" | translate }}</span
      >
    </a>
    } @if (!base.is_example) {
    <a href="javascript:;" (click)="duplicate(base.id)" class="btn pia-tooltip">
      <fa-icon [icon]="faFile"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.duplicate' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.duplicate" | translate }}</span
      >
    </a>
    } @if (!base.is_example) {
    <a href="javascript:;" (click)="remove(base.id)" class="btn pia-tooltip">
      <fa-icon [icon]="faTrash"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.remove' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.remove" | translate }}</span
      >
    </a>
    }
  </div>
</td>
<td class="pia-listsBlock-item">
  @if (!base.is_example) {
  <div contenteditable (focusout)="onFocusOut('name', $event)">
    {{ base.name }}
  </div>
  } @else {
  <div>{{ base.name }}</div>
  }
</td>
<td class="pia-listsBlock-item">
  @if (!base.is_example) {
  <div contenteditable (focusout)="onFocusOut('author', $event)">
    {{ base.author }}
  </div>
  } @else {
  <div>{{ base.author }}</div>
  }
</td>
<td class="pia-listsBlock-item">
  @if (!base.is_example) {
  <div contenteditable (focusout)="onFocusOut('contributors', $event)">
    {{ base.contributors }}
  </div>
  } @else {
  <div>{{ base.contributors }}</div>
  }
</td>
<td class="pia-listsBlock-item">
  <div>{{ nbEntries }}</div>
</td>
